import axios from "axios";
import { api } from "../context/AuthContext";

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "https://api.exihire.com";

const DEMO_API = `${API_BASE_URL}/demo-bookings`;

// PUBLIC
export const createDemoBooking = async (data) => {
  const response = await axios.post(
    DEMO_API,
    data
  );

  return response.data;
};

// SUPER ADMIN
export const getDemoBookings = async (
  params = {}
) => {
  const response = await api.get(
    "/demo-bookings/admin",
    { params }
  );

  return response.data;
};

// SUPER ADMIN
export const getDemoBookingStats = async () => {
  const response = await api.get(
    "/demo-bookings/admin/stats"
  );

  return response.data;
};

// SUPER ADMIN
export const updateDemoBookingStatus = async (
  id,
  status
) => {
  const response = await api.patch(
    `/demo-bookings/admin/${id}/status`,
    { status }
  );

  return response.data;
};

// SUPER ADMIN
export const updateDemoBookingNotes = async (
  id,
  adminNotes
) => {
  const response = await api.patch(
    `/demo-bookings/admin/${id}/notes`,
    { adminNotes }
  );

  return response.data;
};